/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OAuthRequest,
    OAuthRequestFromJSON,
    OAuthRequestToJSON,
    OAuthResponse,
    OAuthResponseFromJSON,
    OAuthResponseToJSON,
} from '../models';

export interface OauthTokenPostRequest {
    oAuthRequest: OAuthRequest;
}

/**
 * 
 */
export class OauthApi extends runtime.BaseAPI {

    /**
     */
    async oauthTokenPostRaw(requestParameters: OauthTokenPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OAuthResponse>> {
        if (requestParameters.oAuthRequest === null || requestParameters.oAuthRequest === undefined) {
            throw new runtime.RequiredError('oAuthRequest','Required parameter requestParameters.oAuthRequest was null or undefined when calling oauthTokenPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/oauth/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthRequestToJSON(requestParameters.oAuthRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthResponseFromJSON(jsonValue));
    }

    /**
     */
    async oauthTokenPost(requestParameters: OauthTokenPostRequest, initOverrides?: RequestInit): Promise<OAuthResponse> {
        const response = await this.oauthTokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
